import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      hideInMenu: true,
      constant: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.base$view.404',
    meta: {
      title: '404',
      hideInMenu: true,
      constant: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.base$view.500',
    meta: {
      title: '500',
      hideInMenu: true,
      constant: true
    }
  },
  {
    name: 'application-activity-manage',
    path: '/application-activity-manage',
    component: 'layout.base$view.application-activity-manage',
    meta: {
      title: '应用活动管理',
      hideInMenu: true,
      activeMenu: 'operate-manage_application-tools',
      icon: 'carbon:application'
    }
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: '工作台',
      hideInMenu: false,
      icon: 'mdi:monitor-dashboard'
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      hideInMenu: true
    }
  },
  {
    name: 'login',
    path: '/login/:id?/:module(pwd-login|code-login|tenant-login)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      hideInMenu: true,
      constant: true
    }
  },
  {
    name: 'manage-commerce',
    path: '/manage-commerce',
    component: 'layout.base',
    meta: {
      title: '商会管理',
      hideInMenu: false,
      icon: 'carbon:enterprise'
    },
    children: [
      {
        name: 'manage-commerce_association-information',
        path: '/manage-commerce/association-information',
        component: 'view.manage-commerce_association-information',
        meta: {
          title: '协会信息',
          hideInMenu: false,
          icon: 'material-symbols:contact-support-outline',
          order: 6
        }
      },
      {
        name: 'manage-commerce_association-journal',
        path: '/manage-commerce/association-journal',
        component: 'view.manage-commerce_association-journal',
        meta: {
          title: '协会期刊',
          hideInMenu: false,
          icon: 'streamline:entertainment-news-paper-newspaper-periodical-fold-content',
          order: 6
        }
      },
      {
        name: 'manage-commerce_association-style',
        path: '/manage-commerce/association-style',
        component: 'view.manage-commerce_association-style',
        meta: {
          title: '协会风采',
          hideInMenu: false,
          icon: 'material-symbols:award-star-outline',
          order: 6
        }
      },
      {
        name: 'manage-commerce_contact-information',
        path: '/manage-commerce/contact-information',
        component: 'view.manage-commerce_contact-information',
        meta: {
          title: '联系方式',
          hideInMenu: false,
          icon: 'weui:mobile-contacts-outlined',
          order: 6
        }
      },
      {
        name: 'manage-commerce_expert-database',
        path: '/manage-commerce/expert-database',
        component: 'view.manage-commerce_expert-database',
        meta: {
          title: '专家库',
          hideInMenu: false,
          icon: 'fluent:task-list-square-database-20-regular',
          order: 6
        }
      },
      {
        name: 'manage-commerce_job-application',
        path: '/manage-commerce/job-application',
        component: 'view.manage-commerce_job-application',
        meta: {
          title: '职务申请',
          hideInMenu: false,
          icon: 'material-symbols:contract-edit-outline'
        }
      },
      {
        name: 'manage-commerce_manage-enterprise',
        path: '/manage-commerce/manage-enterprise',
        component: 'view.manage-commerce_manage-enterprise',
        meta: {
          title: '企业管理',
          hideInMenu: false,
          icon: 'carbon:network-enterprise'
        }
      },
      {
        name: 'manage-commerce_manage-member',
        path: '/manage-commerce/manage-member',
        component: 'view.manage-commerce_manage-member',
        meta: {
          title: '会员管理',
          hideInMenu: false,
          icon: 'icon-park-outline:people'
        }
      },
      {
        name: 'manage-commerce_management-meetings',
        path: '/manage-commerce/management-meetings',
        component: 'view.manage-commerce_management-meetings',
        meta: {
          title: '会议管理',
          hideInMenu: false,
          icon: 'material-symbols:folder-managed-outline',
          order: 6
        }
      },
      {
        name: 'manage-commerce_membership-application',
        path: '/manage-commerce/membership-application',
        component: 'view.manage-commerce_membership-application',
        meta: {
          title: '入会申请',
          hideInMenu: false,
          order: 0,
          icon: 'material-symbols:edit-square-outline'
        }
      },
      {
        name: 'manage-commerce_visit-clock',
        path: '/manage-commerce/visit-clock',
        component: 'view.manage-commerce_visit-clock',
        meta: {
          title: '走访打卡',
          hideInMenu: false,
          icon: 'tabler:camera-heart',
          order: 6
        }
      }
    ]
  },
  {
    name: 'manage-financial',
    path: '/manage-financial',
    component: 'layout.base',
    meta: {
      title: '财务管理',
      hideInMenu: false,
      icon: 'material-symbols:data-table'
    },
    children: [
      {
        name: 'manage-financial_incomexpen-details',
        path: '/manage-financial/incomexpen-details',
        component: 'view.manage-financial_incomexpen-details',
        meta: {
          title: '收支明细',
          hideInMenu: false,
          icon: 'si:wallet-detailed-line'
        }
      },
      {
        name: 'manage-financial_invoice-application',
        path: '/manage-financial/invoice-application',
        component: 'view.manage-financial_invoice-application',
        meta: {
          title: '开票申请',
          hideInMenu: false,
          icon: 'mdi:invoice-text-edit-outline'
        }
      },
      {
        name: 'manage-financial_monthly-ledger',
        path: '/manage-financial/monthly-ledger',
        component: 'view.manage-financial_monthly-ledger',
        meta: {
          title: '月度台账',
          hideInMenu: false,
          icon: 'material-symbols:event-note-sharp'
        }
      },
      {
        name: 'manage-financial_overview',
        path: '/manage-financial/overview',
        component: 'view.manage-financial_overview',
        meta: {
          title: '财务概览',
          hideInMenu: false,
          icon: 'material-symbols:overview-key-outline'
        }
      },
      {
        name: 'manage-financial_payment-approval',
        path: '/manage-financial/payment-approval',
        component: 'view.manage-financial_payment-approval',
        meta: {
          title: '付款审批',
          hideInMenu: false,
          icon: 'fluent:approvals-app-16-filled'
        }
      },
      {
        name: 'manage-financial_payment-list',
        path: '/manage-financial/payment-list',
        component: 'view.manage-financial_payment-list',
        meta: {
          title: '缴费名单',
          hideInMenu: false,
          icon: 'material-symbols:order-approve-outline-rounded'
        }
      },
      {
        name: 'manage-financial_points-details',
        path: '/manage-financial/points-details',
        component: 'view.manage-financial_points-details',
        meta: {
          title: '积分明细',
          hideInMenu: false,
          icon: 'material-symbols:database-outline'
        }
      }
    ]
  },
  {
    name: 'manage-system',
    path: '/manage-system',
    component: 'layout.base',
    meta: {
      title: '系统管理',
      hideInMenu: false,
      icon: 'material-symbols:construction'
    },
    children: [
      {
        name: 'manage-system_data-option',
        path: '/manage-system/data-option',
        component: 'view.manage-system_data-option',
        meta: {
          title: '数据选项',
          hideInMenu: false,
          icon: 'mdi:deviantart'
        }
      },
      {
        name: 'manage-system_manage-dict',
        path: '/manage-system/manage-dict',
        component: 'view.manage-system_manage-dict',
        meta: {
          title: '字典管理',
          hideInMenu: false,
          icon: 'material-symbols:book-2-outline'
        }
      },
      {
        name: 'manage-system_manage-flow',
        path: '/manage-system/manage-flow',
        meta: {
          title: '流程管理',
          hideInMenu: false,
          icon: 'carbon:process'
        },
        children: [
          {
            name: 'manage-system_manage-flow_flow-category',
            path: '/manage-system/manage-flow/flow-category',
            component: 'view.manage-system_manage-flow_flow-category',
            meta: {
              title: '流程分类',
              hideInMenu: false,
              icon: 'carbon:process'
            }
          },
          {
            name: 'manage-system_manage-flow_flow-deploy',
            path: '/manage-system/manage-flow/flow-deploy',
            component: 'view.manage-system_manage-flow_flow-deploy',
            meta: {
              title: '流程部署',
              hideInMenu: false,
              icon: 'carbon:process'
            }
          },
          {
            name: 'manage-system_manage-flow_flow-model',
            path: '/manage-system/manage-flow/flow-model',
            component: 'view.manage-system_manage-flow_flow-model',
            meta: {
              title: '流程模型',
              hideInMenu: false,
              icon: 'carbon:process'
            }
          }
        ]
      },
      {
        name: 'manage-system_manage-role',
        path: '/manage-system/manage-role',
        component: 'view.manage-system_manage-role',
        meta: {
          title: '角色管理',
          hideInMenu: false,
          icon: 'carbon:user-role'
        }
      },
      {
        name: 'manage-system_manage-user',
        path: '/manage-system/manage-user',
        component: 'view.manage-system_manage-user',
        meta: {
          title: '用户管理',
          hideInMenu: false,
          icon: 'material-symbols:manage-accounts-outline'
        }
      },
      {
        name: 'manage-system_menu',
        path: '/manage-system/menu',
        component: 'view.manage-system_menu',
        meta: {
          title: '菜单管理',
          hideInMenu: false,
          icon: 'hugeicons:menu-07'
        }
      },
      {
        name: 'manage-system_message-setting',
        path: '/manage-system/message-setting',
        component: 'view.manage-system_message-setting',
        meta: {
          title: '消息设置',
          hideInMenu: false,
          icon: 'ic:outline-sms'
        }
      },
      {
        name: 'manage-system_param-setting',
        path: '/manage-system/param-setting',
        component: 'view.manage-system_param-setting',
        meta: {
          title: '参数设置',
          hideInMenu: false,
          icon: 'carbon:parameter'
        }
      },
      {
        name: 'manage-system_payment-setting',
        path: '/manage-system/payment-setting',
        component: 'view.manage-system_payment-setting',
        meta: {
          title: '支付设置',
          hideInMenu: false,
          icon: 'carbon:wallet'
        }
      },
      {
        name: 'manage-system_system-log',
        path: '/manage-system/system-log',
        component: 'view.manage-system_system-log',
        meta: {
          title: '系统日志',
          hideInMenu: false,
          icon: 'bi:journal-bookmark-fill'
        }
      },
      {
        name: 'manage-system_system-setting',
        path: '/manage-system/system-setting',
        component: 'view.manage-system_system-setting',
        meta: {
          title: '系统设置',
          hideInMenu: false,
          icon: 'material-symbols-light:settings'
        }
      },
      {
        name: 'manage-system_timed-task',
        path: '/manage-system/timed-task',
        component: 'view.manage-system_timed-task',
        meta: {
          title: '定时任务',
          hideInMenu: false,
          icon: 'material-symbols:alarm-outline'
        }
      }
    ]
  },
  {
    name: 'operate-manage',
    path: '/operate-manage',
    component: 'layout.base',
    meta: {
      title: '运营管理',
      hideInMenu: false,
      icon: 'tdesign:cooperate'
    },
    children: [
      {
        name: 'operate-manage_activity-manage',
        path: '/operate-manage/activity-manage',
        component: 'view.operate-manage_activity-manage',
        meta: {
          title: '活动管理',
          hideInMenu: false,
          icon: 'carbon:accept-action-usage'
        }
      },
      {
        name: 'operate-manage_advertisement-manage',
        path: '/operate-manage/advertisement-manage',
        component: 'view.operate-manage_advertisement-manage',
        meta: {
          title: '广告管理',
          hideInMenu: false,
          icon: 'hugeicons:advertisement'
        }
      },
      {
        name: 'operate-manage_album-manage',
        path: '/operate-manage/album-manage',
        component: 'view.operate-manage_album-manage',
        meta: {
          title: '相册管理',
          hideInMenu: false,
          icon: 'bxs:photo-album'
        }
      },
      {
        name: 'operate-manage_application-tools',
        path: '/operate-manage/application-tools',
        component: 'view.operate-manage_application-tools',
        meta: {
          title: '应用工具',
          hideInMenu: false,
          icon: 'icon-park-solid:application-one'
        }
      },
      {
        name: 'operate-manage_info-manage',
        path: '/operate-manage/info-manage',
        component: 'view.operate-manage_info-manage',
        meta: {
          title: '资讯管理',
          hideInMenu: false,
          icon: 'bxs:news'
        }
      },
      {
        name: 'operate-manage_party-group-manage',
        path: '/operate-manage/party-group-manage',
        component: 'view.operate-manage_party-group-manage',
        meta: {
          title: '党团管理',
          hideInMenu: false,
          icon: 'eos-icons:trusted-organization'
        }
      },
      {
        name: 'operate-manage_supply-hall',
        path: '/operate-manage/supply-hall',
        component: 'view.operate-manage_supply-hall',
        meta: {
          title: '供需大厅',
          hideInMenu: false,
          icon: 'maki:town-hall-15'
        }
      },
      {
        name: 'operate-manage_video-manage',
        path: '/operate-manage/video-manage',
        component: 'view.operate-manage_video-manage',
        meta: {
          title: '视频管理',
          hideInMenu: false,
          icon: 'material-symbols:hangout-video'
        }
      }
    ]
  },
  {
    name: 'personal',
    path: '/personal',
    component: 'layout.base$view.personal',
    meta: {
      title: '个人中心',
      hideInMenu: true,
      activeMenu: 'home'
    }
  },
  {
    name: 'statistical-analysis',
    path: '/statistical-analysis',
    component: 'layout.base',
    meta: {
      title: '统计分析',
      hideInMenu: false,
      icon: 'carbon:text-link-analysis'
    },
    children: [
      {
        name: 'statistical-analysis_commerce-statisticcal',
        path: '/statistical-analysis/commerce-statisticcal',
        component: 'view.statistical-analysis_commerce-statisticcal',
        meta: {
          title: '商会统计',
          hideInMenu: false,
          icon: 'typcn:leaf'
        }
      },
      {
        name: 'statistical-analysis_finance-statistical',
        path: '/statistical-analysis/finance-statistical',
        component: 'view.statistical-analysis_finance-statistical',
        meta: {
          title: '财务统计',
          hideInMenu: false,
          icon: 'tabler:pig-money'
        }
      },
      {
        name: 'statistical-analysis_member-statistical',
        path: '/statistical-analysis/member-statistical',
        component: 'view.statistical-analysis_member-statistical',
        meta: {
          title: '会员统计',
          hideInMenu: false,
          icon: 'fluent:accessibility-16-regular'
        }
      },
      {
        name: 'statistical-analysis_operations-statistical',
        path: '/statistical-analysis/operations-statistical',
        component: 'view.statistical-analysis_operations-statistical',
        meta: {
          title: '运营统计',
          hideInMenu: false,
          icon: 'proicons:airplane'
        }
      },
      {
        name: 'statistical-analysis_points-statistics',
        path: '/statistical-analysis/points-statistics',
        component: 'view.statistical-analysis_points-statistics',
        meta: {
          title: '积分统计',
          hideInMenu: false,
          icon: 'material-symbols:app-registration-outline-rounded'
        }
      }
    ]
  },
  {
    name: 'tenant-manage',
    path: '/tenant-manage',
    component: 'layout.base',
    meta: {
      title: '租户管理',
      hideInMenu: false,
      icon: 'mdi:account-settings-variant'
    },
    children: [
      {
        name: 'tenant-manage_tenant-list',
        path: '/tenant-manage/tenant-list',
        component: 'view.tenant-manage_tenant-list',
        meta: {
          title: '租户列表',
          hideInMenu: false,
          icon: 'mdi:chart-timeline-variant'
        }
      }
    ]
  }
];
